import { render, staticRenderFns } from "./AddressModal.html?vue&type=template&id=61511fa2&scoped=true&"
import script from "./AddressModal.vue?vue&type=script&lang=js&"
export * from "./AddressModal.vue?vue&type=script&lang=js&"
import style0 from "./AddressModal.scss?vue&type=style&index=0&id=61511fa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61511fa2",
  null
  
)

export default component.exports